/**
 * The answer whose belief is still on its way, as a turn number, until its wait runs out.
 *
 * A poll re-renders the page only when the data changes, so a belief that never lands would
 * leave "Updating…" up for good; a timer re-renders once at the deadline to take it down.
 */

import { useEffect, useState } from "react";

import { pendingAnswer, type BeliefIndex } from "./liveBeliefs";

export function usePendingTurn(index: BeliefIndex, active: boolean): number | null {
  const pending = pendingAnswer(index, active);
  const until = pending?.until ?? null;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (until === null || !Number.isFinite(until)) return;
    const wait = until - Date.now();
    if (wait <= 0) {
      setNow(Date.now());
      return;
    }
    const timer = window.setTimeout(() => setNow(Date.now()), wait);
    return () => window.clearTimeout(timer);
  }, [until]);

  return pending !== null && now < pending.until ? pending.turnNumber : null;
}
